import React from 'react'
import Notfound from '../Error/Notfound'

function NotFound() {
  return (
    <>
        <Notfound />
    </>
  )
}

export default NotFound
